import styled from '@emotion/styled';

import { hoverable } from '../../interaction-states';
import { typographyVariantStyles } from '../../typography-variants';

export const StyledHeader = styled('div')({
  display: 'flex',
  alignSelf: 'stretch',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: 32,
  gap: 8,
  paddingTop: '1px',
});

// Keeps the month label centred when a range calendar hides one of its arrows;
// the label is `flex: 1`, so without this it slides into the freed space.
export const StyledArrowSpacer = styled('span')({
  width: 32,
  height: 32,
  flexShrink: 0,
});

// Range mode has no Set Date view to open, so its label is inert and must not
// carry the clickable label's hover affordance.
export const StyledStaticMonthLabel = styled('span')(({ theme }) => ({
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  color: theme.colors.text.primary,
  ...typographyVariantStyles.body3,
  fontWeight: 500,
}));

export const StyledMonthLabel = styled('button')(({ theme }) => ({
  ...hoverable(theme),
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  gap: 4,
  background: 'none',
  border: 'none',
  borderRadius: theme.radius[4],
  padding: 0,
  cursor: 'pointer',
  color: theme.colors.text.primary,
  ...typographyVariantStyles.body3,
  fontWeight: 500,
}));

export const StyledSetDateToggle = styled('button')(({ theme }) => ({
  ...hoverable(theme),
  display: 'flex',
  alignSelf: 'stretch',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  gap: 8,
  background: 'none',
  border: 'none',
  borderRadius: theme.radius[4],
  padding: 0,
  cursor: 'pointer',
  color: theme.colors.brand.text,
  ...typographyVariantStyles.body3,
  fontWeight: 500,

  '& svg': {
    width: 16,
    height: 16,
    flexShrink: 0,
    color: theme.colors.brand.text,
  },
}));
